<div *ngIf="SSO">
    <div id="overlay-sso">
        <div class="overlay-message"></div>
    </div>    
    <app-progress-spinner-v2 *ngIf="isLoading"></app-progress-spinner-v2>
</div>
 
<div *ngIf="!SSO">
        <div id="overlay">
                <div class="overlay-message"></div>
            </div>
            <div class="full-page">    
                <div class="login-card">
                    <div class="card-content">
                        <!-- <p *ngIf="userExist == false">You don't have access to the portal, please contact DHL support.</p> -->
                        <form [formGroup]="loginForm" (ngSubmit)="login()">
                            <!-- <div class="error-message" id="error" *ngIf="errorMessage">{{errorMessage}}</div> -->
                            <div style="margin-bottom: 20px;">
                                    <h1 class="m-Opener-headline" style="margin-bottom: 0;
                                    position: relative;
                                    text-align: left;">
                                        WELCOME </h1>
                                <span class=" m-Opener-topline" style="
                                position: relative;
                                text-align: left;">Transport Portal</span>                    
                            </div>                                
                            <div class="form-field">
                                <label class="field-label">User Name</label>
                                <input class="form-control input-field" formControlName="username" autocomplete="off" [ngClass]="{ 'is-invalid': submitted && loginForm.get('username').errors }">
                                <div *ngIf="f.username.errors && submitted" class="error-text">
                                    <div *ngIf="f.username.errors.required">
                                        Required
                                    </div>
                                </div>
                            </div>
                            <div class="form-field">
                                <label class="field-label">Password</label>
                                <input type="password" class="form-control input-field" formControlName="password" autocomplete="off" [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
                                <div *ngIf="f.password.errors && submitted" class="error-text">
                                    <div *ngIf="f.password.errors.required">                                
                                        Required
                                    </div>
                                </div>
                            </div>
                            <div>                    
                                <button type="submit" [disabled]="isLoading" class="dhl-button input-field">Sign in</button>
                            </div>
                        </form>
                    </div>
                    <app-progress-spinner-v2 *ngIf="isLoading"></app-progress-spinner-v2>
                </div>
            </div> 
</div>
